<div class="circle-container mb-4">
  <div class="circle" [class.circle__onSurface]="onSurface()"></div>
  <img [src]="imageSource()" [alt]="altTag()" class="center-image" />
</div>
